import axios from 'axios'
import { MENUS } from '../config/sites'

// Списки фото из старого API приходят то массивом, то строкой «ссылка, ссылка» (так хранились поля Пицунды и Амари в списках)
export function toList (value) {
  if (Array.isArray(value)) return value.filter(Boolean)
  if (typeof value === 'string' && value.trim()) {
    return value.split(/\s*,\s*(?=https?:\/\/)/i).map(s => s.trim()).filter(Boolean)
  }
  return []
}

export function toRows (value) {
  if (Array.isArray(value)) return value
  if (value && typeof value === 'object') return Object.values(value).filter(item => item && typeof item === 'object')
  return []
}

// Поля с фотографиями услуг и ресторанов: Гагра 644 и 646, Пицунда 674, Амари 696
export const GALLERY_FIELDS = [138, 643, 644, 645, 646, 663, 673, 674, 686, 695, 696]

// Есть ли на странице услуги или ресторана что показать: фото или текст. Пустую страницу не открываем.
export function hasPage (item) {
  const cf = (item && item.cf) || {}
  const html = String((item && item.html) || '')
  const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;|\s/gi, '').trim()
  return GALLERY_FIELDS.some(f => toList(cf[f]).length > 0) || !!text || /<img\b[^>]*\bsrc\s*=/i.test(html)
}

export function hasGalleryPage (item, field = 138) {
  const cf = (item && item.cf) || {}
  const html = String((item && item.html) || '')
  const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;|\s/gi, '').trim()
  return toList(cf[field]).length > 0 || !!text || /<img\b[^>]*\bsrc\s*=/i.test(html)
}

const menuCache = new Map()
const MENU_LISTS = {
  abaata: { services: 3, restaurants: 4, galleries: 5 },
  pitsunda: { services: 52 },
  amari: { services: 56 }
}

function getList (id) {
  return axios.get('https://api.abaata.ru/list/get-lists?id=' + id + '&site=1').then(({ data }) => toRows(data))
}

/** Убирает из шапки и подвала ссылки на услуги, рестораны и галереи без содержимого. */
export function getVisibleMenu (site) {
  const key = site === 'picunda' ? 'pitsunda' : site
  const configured = MENUS[key] || MENUS.abaata
  const cached = menuCache.get(key)
  if (cached && cached.until > Date.now()) return cached.promise

  const lists = MENU_LISTS[key] || {}
  const promise = Promise.all(Object.entries(lists).map(([name, id]) => getList(id).then(rows => [name, rows])))
    .then(entries => {
      const data = Object.fromEntries(entries)
      const services = toRows(data.services).filter(hasPage)
      const restaurants = toRows(data.restaurants).filter(hasPage)
      const galleryField = key === 'abaata' ? 138 : 663
      const galleries = toRows(data.galleries).filter(item => hasGalleryPage(item, galleryField))
      const serviceIds = new Set(services.map(item => String(item.id)))
      const restaurantIds = new Set(restaurants.map(item => String(item.id)))
      const galleryAvailable = galleries.length > 0

      return configured.map(item => {
        if (item.link === '/services/' && !services.length) return null
        if (item.link === '/restaurants/' && !restaurants.length) return null
        const child = (item.child || []).filter(link => {
          const service = /^\/service\/(\d+)/.exec(link.link)
          const restaurant = /^\/restaurant\/(\d+)/.exec(link.link)
          if (service) return serviceIds.has(service[1])
          if (restaurant) return restaurantIds.has(restaurant[1])
          if (link.link === '/about/gallery/') return galleryAvailable
          return true
        })
        if (item.child && !child.length && ['/services/', '/restaurants/'].includes(item.link)) return null
        return { ...item, child }
      }).filter(Boolean)
    })
    .catch(() => configured)

  menuCache.set(key, { promise, until: Date.now() + 5 * 60 * 1000 })
  return promise
}
